"use strict";
/* eslint-disable max-lines-per-function */
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedBarGraph = void 0;
const React = __importStar(require("react"));
const bar_1 = require("@nivo/bar");
const constants_1 = require("./constants");
exports.StackedBarGraph = ({ data, keys, indexName, vAxisTitle, hAxisTitle, addFilter, }) => (React.createElement(bar_1.ResponsiveBar, { data: data, keys: keys, indexBy: indexName, margin: { top: 50, right: 130, bottom: 50, left: 60 }, padding: 0.3, colors: constants_1.STACKED_GRAPH_COLORS, onClick: (_a) => {
        var node = __rest(_a, []);
        addFilter(node.id, node.indexValue);
    }, borderColor: { from: 'color' }, axisTop: null, axisRight: null, axisBottom: {
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: hAxisTitle,
        legendPosition: 'middle',
        legendOffset: 32,
    }, axisLeft: {
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: vAxisTitle,
        legendPosition: 'middle',
        legendOffset: -55,
    }, labelSkipWidth: 12, labelSkipHeight: 12, labelTextColor: "#ffffff", legends: [
        {
            dataFrom: 'keys',
            anchor: 'right',
            direction: 'column',
            justify: false,
            translateX: 109,
            translateY: 2,
            itemsSpacing: 1,
            itemWidth: 82,
            itemHeight: 32,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 18,
            symbolShape: 'circle',
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemOpacity: 1,
                    },
                },
            ],
        },
    ], animate: true }));
//# sourceMappingURL=data:application/json;base64,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